module.exports = __webpack_public_path__ + "static/media/shish-kebab.c35de802.svg";